import { render, staticRenderFns } from "./ncbplacarding.vue?vue&type=template&id=27a0389e"
import script from "./ncbplacarding.vue?vue&type=script&lang=js"
export * from "./ncbplacarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports